import {gql, useMutation} from '@apollo/client';
import {Pda} from './components/Pda';
import {Header} from './components/Header';
import { ArrivalRelatedScanComponent } from './components/ArrivalRelatedScanComponent';
import { HandleScanEventResult } from './components/VehicleRelatedScanComponent';
import { t } from '../../i18n';


const HANDLE_WHS_ARRIVAL_SCAN_EVENT = gql`
   mutation HandleWhsArrivalScanEvent($barCode: String!) {
     success: handleWhsArrivalScanEvent(barCode: $barCode)
   }
` 

const PageBody = () => {
    const [handleWhsArrivalScanEvent] = useMutation<HandleScanEventResult>(HANDLE_WHS_ARRIVAL_SCAN_EVENT);

    const handleScanEvent = async (barCode: string): Promise<HandleScanEventResult> => {
        const {data} = await handleWhsArrivalScanEvent({ variables: { barCode } });
        return {success: data?.success || false};
    };

    return (
        <ArrivalRelatedScanComponent
         value1Placeholder={t('pda.pages.whsArrival.bagCodeTrackingNo')} 
         value1ColumnTitle={t('pda.common.bagPackage')} 
         handleScanEvent={handleScanEvent} />
    );
}

export default function WhsArrivalPage() {
    return (
        <div className="w-full h-full flex flex-col gap-2 p-2">
            <Header title={t('pda.pages.whsArrival.whsArrivalScan')}/>
            <Pda/>
            <PageBody/>
        </div>
    );
}